// The one definition of the priority actions card of a dashboard (SEP-296).
// The Desk slot card and the page-owned modules of the Ops and Comply
// dashboards use it. The file has no React, so that a feature file can
// import it without the panel.

/** The fields of the priority actions card that each dashboard shares. */
export const PRIORITY_ACTIONS_CARD = {
    key: 'priority-actions',
    title: 'Priority actions',
    summary: 'The work that waits on you, until it is done.',
    span: 12,
    rows: 2,
    emptyBehaviour: 'collapse',
    countLabel: (count: number) => `${count} open`,
} as const;

/**
 * The count of the card. The panel renders nothing while its read is
 * pending, or after a read that failed. Thus a count that is not known
 * counts as 0: the card collapses to its header, and the cell is not empty.
 */
export function priorityActionsCardCount(count: number | null): number {
    return count ?? 0;
}
